import { supabase, isSupabaseConfigured } from '../../lib/supabase'

export default function AdminLogin() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!isSupabaseConfigured) return
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) navigate('/admin/dashboard')
    })
  }, [])

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!isSupabaseConfigured) {
      setError('Supabase nije konfigurisan. Dodajte VITE_SUPABASE_URL i VITE_SUPABASE_ANON_KEY u .env fajl.')
      return
    }
    setLoading(true)
    setError('')
    const { error: err } = await supabase.auth.signInWithPassword({ email, password })
    if (err) {
      setError('Pogrešan email ili lozinka.')
    } else {
      navigate('/admin/dashboard')
    }
    setLoading(false)
  }

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
              <i className="ri-shield-check-fill text-white text-xl" />
            </div>
            <span className="text-white text-xl font-bold">SafeGuard CMS</span>
          </div>
          <p className="text-slate-400 text-sm">Admin panel — prijavite se</p>
        </div>

        <div className="bg-slate-800 rounded-2xl p-8 border border-slate-700">
          <form onSubmit={handleLogin} className="space-y-5">
            <div>
              <label className="block text-slate-300 text-sm font-medium mb-2">Email adresa</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-3 text-white placeholder-slate-400 focus:outline-none focus:border-blue-500 transition"
                placeholder="admin@safeguard-systems.rs"
              />
            </div>
            <div>
              <label className="block text-slate-300 text-sm font-medium mb-2">Lozinka</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                className="w-full bg-slate-700 border border-slate-600 rounded-lg px-4 py-3 text-white placeholder-slate-400 focus:outline-none focus:border-blue-500 transition"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div className="bg-red-900/40 border border-red-700 rounded-lg px-4 py-3 text-red-300 text-sm">
                {error}
              </div>
            )}

            {!isSupabaseConfigured && (
              <div className="bg-amber-900/40 border border-amber-700 rounded-lg px-4 py-3 text-amber-300 text-sm">
                <p className="font-medium mb-1">Supabase nije podešen</p>
                <p>Kreirajte <code className="bg-amber-800/50 px-1 rounded">.env</code> fajl sa:</p>
                <pre className="mt-2 text-xs font-mono bg-amber-950/50 rounded p-2 whitespace-pre-wrap">
VITE_SUPABASE_URL=https://xxx.supabase.co{'\n'}VITE_SUPABASE_ANON_KEY=your-key
                </pre>
              </div>
            )}

            <button
              type="submit"
              disabled={loading || !isSupabaseConfigured}
              className="w-full bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold py-3 rounded-lg transition"
            >
              {loading ? 'Prijavljivanje...' : 'Prijavi se'}
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-slate-700">
            <p className="text-slate-500 text-xs text-center">
              Admin korisnika kreirajte u <strong className="text-slate-400">Supabase Dashboard → Authentication → Users</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
